/**
 * Venner · Banderas en los selectores de país.
 *
 * Pone la bandera oficial de Shopify junto a cada enlace de país del header y cambia el
 * enlace del footer ("Change country") por el país donde está comprando el visitante.
 *
 * Funciona en las dos tiendas aunque su menú esté armado distinto: en venner.com.mx el
 * selector es un snippet propio, en vennershop.com es un desplegable normal de la
 * navegación. En vez de depender del marcado, el país de cada enlace se deduce de su
 * texto ("México (MXN)" → MX) contra los nombres de región del navegador, sin acentos y
 * en el idioma de la página y en inglés. Así el menú se sigue editando desde Shopify sin
 * escribir códigos ISO en ningún lado.
 *
 * Configuración por atributos data- en la etiqueta <script> que lo carga.
 */

(() => {
  if (window.vennerFlagsReady) return;
  window.vennerFlagsReady = true;

  const config = (document.currentScript && document.currentScript.dataset) || {};
  const CDN = 'https://cdn.shopify.com/static/images/flags/';

  // Un desplegable se considera "de países" solo si varios de sus enlaces lo son. Evita
  // ponerle una bandera a un menú de ayuda que por casualidad tenga un país en su texto.
  const MIN_COUNTRY_LINKS = 2;

  const plain = (value) =>
    value
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  /*
    Mapa nombre → ISO construido al vuelo: se recorren las 676 combinaciones de dos letras
    y se conservan las que el navegador reconoce como región. Evita enviar una tabla de
    países y funciona igual si el menú se escribe en otro idioma.
  */
  let lookup = null;

  function nameToIso(label) {
    if (!lookup) {
      lookup = new Map();
      for (const locale of [document.documentElement.lang || 'en', 'en']) {
        let names;
        try {
          names = new Intl.DisplayNames([locale], { type: 'region' });
        } catch (error) {
          continue;
        }
        for (let a = 65; a <= 90; a += 1) {
          for (let b = 65; b <= 90; b += 1) {
            const iso = String.fromCharCode(a, b);
            const name = names.of(iso);
            if (name && name !== iso) {
              const key = plain(name);
              if (!lookup.has(key)) lookup.set(key, iso);
            }
          }
        }
      }
    }
    return lookup.get(plain(label)) || null;
  }

  function flag(iso) {
    const img = document.createElement('img');
    img.className = 'venner-flag';
    img.src = CDN + iso.toLowerCase() + '.svg';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 20;
    img.height = 14;
    return img;
  }

  function decorate(anchor, iso) {
    if (anchor.querySelector('.venner-flag')) return;
    anchor.classList.add('venner-flag-link');
    anchor.prepend(flag(iso));
  }

  function enhance() {
    // ---------------------------------------------------------------- header
    document.querySelectorAll('.header__dropdown-menu, .venner-country__menu').forEach((menu) => {
      const found = [];
      menu.querySelectorAll('a').forEach((anchor) => {
        const iso = nameToIso(anchor.textContent);
        if (iso) found.push([anchor, iso]);
      });
      if (found.length >= MIN_COUNTRY_LINKS) {
        found.forEach(([anchor, iso]) => decorate(anchor, iso));
      }
    });

    // ---------------------------------------------------------------- footer
    if (config.footer !== 'true' || !config.iso || !config.country) return;

    document.querySelectorAll('.footer__block a[href*="/pages/markets"]').forEach((link) => {
      if (link.querySelector('.venner-flag')) return;
      link.textContent = '';
      link.classList.add('venner-flag-link', 'venner-flag-link--footer');
      link.append(flag(config.iso), document.createTextNode(config.country));
    });
  }

  /*
    El script se carga desde el header o desde una sección del grupo overlay, así que al
    ejecutarse el navegador todavía no ha leído el footer ni el cajón móvil. Hay que
    esperar a que el documento esté completo o esos elementos no existen todavía.
  */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
})();
